import React from 'react';
import { gettext } from 'core/utils/text';

const EmptyState = () => (
    <div>{gettext('No pipes today, please check again tomorrow :(')}</div>
);

export default EmptyState;
